import { gql, gqlFetch } from "@insightfulscience/shared-utils/gqlFetch/gqlFetch";
import { publicConfig } from "../config";
import { RefreshToken, Token, clearAll } from "../persistent-storage";

const runGql = gqlFetch(
	typeof window === "undefined" ? publicConfig.GRAPHQL_INTERNAL_URI : publicConfig.GRAPHQL_URI,
);

export const whenNotAuthorized = ({ code }) => code === 401;

const REFRESH_ACCESS = gql`
	mutation refreshAccess($refreshToken: String!) {
		refreshAccess(refreshToken: $refreshToken) {
			token
			refreshToken
		}
	}
`;

export const recoverNotAuthorized = (context, requestHandler) => {
	let recoveringPromise = null;
	return operation => {
		recoveringPromise =
			recoveringPromise ||
			runGql(REFRESH_ACCESS, { refreshToken: RefreshToken(context).read() })
				.then(({ refreshAccess }) => refreshAccess)
				.then(({ token, refreshToken }) => {
					Token(context).set(token);
					RefreshToken(context).write(refreshToken, { expires: 365 });
					recoveringPromise = null;
				})
				.catch(err => {
					clearAll(context);
					return Promise.reject(err);
				});

		return recoveringPromise.then(() => requestHandler(operation));
	};
};
